export default "__VITE_ASSET__Bp4yXF7v__"